var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgReferralBackgroundMobile = function SvgReferralBackgroundMobile(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 390,
    height: 844,
    viewBox: "0 0 390 844",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1769",
    "data-name": "Rectangle 1769",
    width: 390,
    height: 844,
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_63",
    "data-name": "Mask Group 63",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3915",
    "data-name": "Group 3915"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1751",
    "data-name": "Rectangle 1751",
    width: 390,
    height: 844,
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_499",
    "data-name": "Ellipse 499",
    cx: 129,
    cy: 129,
    r: 129,
    transform: "translate(-103 -133)",
    fill: "#4dc5b6",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_559",
    "data-name": "Ellipse 559",
    cx: 129,
    cy: 129,
    r: 129,
    transform: "translate(286 81)",
    fill: "#4dc5b6",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_560",
    "data-name": "Ellipse 560",
    cx: 60,
    cy: 60.5,
    rx: 60,
    ry: 60.5,
    transform: "translate(303 287)",
    fill: "#c37dce",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_561",
    "data-name": "Ellipse 561",
    cx: 129,
    cy: 129,
    r: 129,
    transform: "translate(-83 715)",
    fill: "#4dc5b6",
    opacity: 0.3
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgReferralBackgroundMobile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "referral-background-mobile.585779fa5efecc50ce0188fc817849a6.svg";